import React from 'react';
import { useLocation, Switch, Route } from 'react-router-dom';

import DeveloperDashboardNavigator from './DeveloperDashboardNavigator';
import HomeNavigatorRoutes from './HomeNavigator';
import ManagerNavigator from './ManagerNavigator';
import AdminNavigator from './AdminNavigator';
import { NotFoundPage } from '../../pages';

const ScrollToTop: React.FC<any> = ({ children }) => {
  const location = useLocation();
  React.useEffect(() => window.scrollTo(0, 0), [location.pathname]);
  return children;
};

const Routes = () => (
  <ScrollToTop>
    <Switch>
      {HomeNavigatorRoutes}
      {DeveloperDashboardNavigator}
      {ManagerNavigator}
      {AdminNavigator}

      <Route path="*" component={NotFoundPage} />
    </Switch>
  </ScrollToTop>
);

export default Routes;
